@let country = tspCountry$ | async;
@let usernamePrefix = (tspUsernamePrefix$ | async) ?? '';

<app-fleet-page-header
  (clearSearch)="model.setSearch('')"
  (searchChanged)="model.setSearch($event)"
  (sortChanged)="model.setOrder($event)"
  (export)="model.exportReport($event)"
  [templates]="{ description, actionButtons, rightControls, countIcon }"
  [columns]="state.columns$ | async"
  [counter]="(state.count$ | async) ?? 0"
  [search]="state.search$ | async"
  [sortOrder]="state.gridSortOrder$ | async"
  [defaultSortOrder]="state.defaultSortOrder$ | async"
  [titleText]="'users.title' | translate"
  [useSearchShort]="true"
  [showSearch]="true"
  [showCounter]="true"
  [showExport]="true"
  [showActionsSpacer]="true"
  [showPdfExportOption]="false"
  [showMobileMenuButton]="false"
  [showMobileCounterIcon]="true"
  [showExportAlwaysCompact]="true"
></app-fleet-page-header>

<ng-template #description>
  <span>
    <span class="text-14 fw-400 color-gray-500">
      {{ 'users.description.0' | translate }}
    </span>
    <span
      class="text-14 fw-400 color-gray-500 link clickable underline"
      [routerLink]="['/accounts']"
    >
      {{ 'tsp-admin.fleets.title' | translate }}
    </span>
    <span class="text-14 fw-400 color-gray-500">{{ 'users.description.1' | translate }}</span>
  </span>
</ng-template>

<ng-template #countIcon>
  <app-icon-users [height]="22" [width]="22"></app-icon-users>
</ng-template>

<ng-template #rightControls
  ><p-button
    class="h--40 p--16 text-14 fw-500"
    [appCheckAccess]="[Resource.Role, Action.View]"
    [appTooltip]="'roles.tooltips.role-management' | translate"
    [icon]="'pi'"
    [routerLink]="['/roles']"
    [severity]="'secondary'"
    [tooltipPosition]="'top'"
  >
    <app-icon-case
      class="icon"
      [width]="20"
      [height]="20"
      [color]="'var(--icon-color)'"
    ></app-icon-case></p-button
></ng-template>

<ng-template #actionButtons let-isMobile="isMobile">
  <p-button
    class="h--40 p--16 text-14 fw-500"
    [icon]="isMobile ? 'pi' : ''"
    [severity]="'primary'"
    [appCheckAccess]="[Resource.User, Action.Create]"
    (click)="addUserDialog.open()"
  >
    <app-icon-plus [height]="20" [width]="20" class="icon"></app-icon-plus>
    @if (!isMobile) {
      {{ 'users.add-btn' | translate }}
    }
  </p-button>
</ng-template>

<app-users-grid
  [displayColumns]="['user', 'auditId', 'role', 'mfa', 'lastActivity', 'actions']"
></app-users-grid>

@if (state.selectedItem$ | async; as userData) {
  <app-edit-user-dialog
    [opened]="true"
    [user]="userData"
    [mode]="TYPES.UserFormMode.TSP"
    [country]="country ?? CountryCodes.UnitedStates"
    [usernamePrefix]="usernamePrefix"
    (closed)="model.unselect()"
  ></app-edit-user-dialog>
}

<app-add-user-dialog
  #addUserDialog
  [mode]="TYPES.UserFormMode.TSP"
  [country]="country ?? CountryCodes.UnitedStates"
  [usernamePrefix]="usernamePrefix"
></app-add-user-dialog>
